<template>
    <v-container
            fluid
            tag="section"
            pt-0
    >
        <v-card>
            <v-card-text>
                <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                >
                    <v-container>
                        <v-row>
                            <v-col
                                    cols="12"
                                    sm="6"
                            >
                                <v-text-field
                                        v-model="localTimeOffset"
                                        :label="$vuetify.lang.t('$vuetify.page.Settings.localTimeOffset')"
                                        :rules="[fieldValidationRules.required(vue)]"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                    cols="12"
                                    sm="6"
                            >
                                <v-text-field
                                        v-model="delayedServiceNotificationOffset"
                                        :label="$vuetify.lang.t('$vuetify.page.Settings.delayedServiceNotificationOffset')"
                                        :rules="[fieldValidationRules.required(vue)]"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                    cols="12"
                                    sm="6"
                            >
                                <v-select
                                        v-model="serviceNumberSeriesId"
                                        :items="seriesNumberDictionaryList"
                                        item-value="id"
                                        item-text="name"
                                        :label="$vuetify.lang.t('$vuetify.page.Settings.serviceNumberSeries')"
                                        :rules="[fieldValidationRules.required(vue)]"
                                ></v-select>
                            </v-col>
                            <v-col
                                    cols="12"
                                    sm="6"
                            >
                                <v-select
                                        v-model="clientTicketNumberSeriesId"
                                        :items="seriesNumberDictionaryList"
                                        item-value="id"
                                        item-text="name"
                                        :label="$vuetify.lang.t('$vuetify.page.Settings.clientTicketNumberSeries')"
                                        :rules="[fieldValidationRules.required(vue)]"
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        color="blue darken-1"
                        text
                        @click="setSettingData"
                        :loading="axiosLoading" :disabled="!valid"
                >
                    {{$vuetify.lang.t('$vuetify.page.action.btnSave')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "Settings",
        created() {
            this.$store.dispatch('retrieveSettingData')
            this.$store.dispatch('retrieveSeriesNumberDictionaryList')
        },
        computed: {
            ...mapState(['barColor', 'barImage']),
            settingData() {
                return this.$store.getters.settingData
            },
            seriesNumberDictionaryList() {
                return this.$store.getters.seriesNumberDictionaryList
            },
        },
        watch:{
            settingData(){
                this.localTimeOffset = this.settingData.localTimeOffset
                this.delayedServiceNotificationOffset = this.settingData.delayedServiceNotificationOffset
                this.serviceNumberSeriesId = this.settingData.serviceNumberSeries?.id
                this.clientTicketNumberSeriesId = this.settingData.clientTicketNumberSeries?.id
            }
        },
        data() {
          return {
              localTimeOffset: this.settingData ? this.settingData.localTimeOffset : 'ss',
              delayedServiceNotificationOffset: this.settingData ? this.settingData.delayedServiceNotificationOffset : 1,
              serviceNumberSeriesId: this.settingData ? this.settingData.serviceNumberSeries.id : null,
              clientTicketNumberSeriesId: this.settingData ? this.settingData.clientTicketNumberSeries.id : null,
              vue: this,
              valid: !this.formError,
          }
        },
        methods: {
            setSettingData(){
                this.$store.dispatch('setSettingData', {
                    localTimeOffset: this.localTimeOffset,
                    delayedServiceNotificationOffset: this.delayedServiceNotificationOffset*1,
                    serviceNumberSeriesId: this.serviceNumberSeriesId,
                    clientTicketNumberSeriesId: this.clientTicketNumberSeriesId,
                })
            }
        }
    }
</script>

<style scoped>

</style>